module.exports = __webpack_public_path__ + "media/images/emblems/Hedingen-blazon-fc5dd1eef3f1e6ea27bb26174171a585.svg";